<template>
  <section :style="{ 'min-height': 'calc(100vh - ' + $vuetify.application.top + 'px)' }">
    <v-container class="text-center">
      <h2 class="display-2 font-weight-bold mb-3">ABOUT {{appName.toUpperCase()}}</h2>

      <v-responsive class="mx-auto mb-8" width="56">
        <v-divider class="mb-1"></v-divider>
        <v-divider></v-divider>
      </v-responsive>

      <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720">
        <p>{{appName.toUpperCase()}} is a bot manangement app for Telegram® bots.</p>
        <p>It uses a Telegram® bot that you create to automate group management and trigger different functionality based on member message content.</p>
        <p>Large messaging groups are time intensive to maintain and manage, why not let your own bot do that for you?</p>

        <v-banner single-line elevation="2" class="my-10 text-center">
          <v-avatar slot="icon" color="accent" size="50">
            <v-icon>mdi-gift</v-icon>
          </v-avatar>
          <p class="title pt-4">You can try {{appName.toUpperCase()}} free for 14 days!</p>
          <template v-slot:actions>
            <v-btn outlined x-large color="primary" :to="{ name: 'signup' }">Sign Up</v-btn>
          </template>
        </v-banner>

        <p>It's easy to get started, so let's help you manage your groups!</p>
      </v-responsive>

      <!--<v-avatar class="elevation-12 mb-12" size="128">
        <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
      </v-avatar>-->

      <v-btn class="mt-10" color="grey" href="https://docs.groupbot.app" outlined large>
        <span class="grey--text text--darken-1 font-weight-bold">{{appName}} Documentation</span>
      </v-btn>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("app", ["appName"])
  }
};
</script>